// extracted by mini-css-extract-plugin
module.exports = {"root":"Controls_root__siV-e","header":"Controls_header__1ABvE text-md","controls":"Controls_controls__3dV4Y"};